import { render } from "./LayoutAuthSidebarContentMenu.vue?vue&type=template&id=563d8ed5&ts=true"
import script from "./LayoutAuthSidebarContentMenu.vue?vue&type=script&lang=ts"
export * from "./LayoutAuthSidebarContentMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__